import { Icon, Text } from '@betty/moonlight';
import styles from './BundleRewards.module.css';
import { PromotionReward } from '@betty/promos';
import { getLandingRewardAmount } from '../../../../../utils/getLandingRewardAmount';
import { rewardDescriptionMap } from './BundleRewards.constants';

function BundleRewards({ rewards }: { rewards?: PromotionReward[] }) {
  return (
    <div className={styles.bundleRewardsWrapper}>
      {rewards?.map((reward, index) => (
        <div key={index} className={styles.bundleReward}>
          <Text
            variant="h4"
            gradient="darkSurfaceAccent"
            uppercase
            textAlign="center"
          >
            {getLandingRewardAmount(reward)}
          </Text>
          <Text
            variant="h6"
            gradient="darkSurfaceAccent"
            uppercase
            textAlign="center"
          >
            {rewardDescriptionMap.get(reward.rewardTarget)}
          </Text>
          {index < rewards.length - 1 && (
            <div className={styles.plusSeparator}>
              <Icon name="plusReward" width={27} height={27} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default BundleRewards;
